import { ActionCreator } from "./../types/store-types";
import {
    AddMarkerRequestActionType,
    AddMarkerFailureActionType,
    AddMarkerSuccessActionType,
    DeleteMarkerRequestActionType,
    DeleteMarkerFailureActionType,
    DeleteMarkerSuccessActionType,
    InitalMarkerActionType,
    InitMarkersActionType,
    MarkersActionTypes,
    UpdateMarkerRequestActionType,
    UpdateMarkerFailureActionType,
    UpdateMarkerSuccessActionType,
} from "./types";

export const initMarkers: ActionCreator<InitMarkersActionType> = payload => ({
    type: MarkersActionTypes.INIT_MARKERS,
    payload,
});

export const initalMarker: ActionCreator<InitalMarkerActionType> = payload => ({
    type: MarkersActionTypes.INITAL_MARKER,
    payload,
});

export const addMarkerRequest: ActionCreator<AddMarkerRequestActionType> = payload => ({
    type: MarkersActionTypes.ADD_MARKER_REQUEST,
    payload,
});
export const addMarkerSuccess: ActionCreator<AddMarkerSuccessActionType> = payload => ({
    type: MarkersActionTypes.ADD_MARKER_SUCCESS,
    payload,
});
export const addMarkerFailure: ActionCreator<AddMarkerFailureActionType> = payload => ({
    type: MarkersActionTypes.ADD_MARKER_FAILURE,
    payload,
});

export const deleteMarkerRequest: ActionCreator<DeleteMarkerRequestActionType> = payload => ({
    type: MarkersActionTypes.DELETE_MARKER_REQUEST,
    payload,
});
export const deleteMarkerSuccess: ActionCreator<DeleteMarkerSuccessActionType> = payload => ({
    type: MarkersActionTypes.DELETE_MARKER_SUCCESS,
    payload,
});
export const deleteMarkerFailure: ActionCreator<DeleteMarkerFailureActionType> = payload => ({
    type: MarkersActionTypes.DELETE_MARKER_FAILURE,
    payload,
});

export const updateMarkerRequest: ActionCreator<UpdateMarkerRequestActionType> = payload => ({
    type: MarkersActionTypes.UPDATE_MARKER_REQUEST,
    payload,
});
export const updateMarkerSuccess: ActionCreator<UpdateMarkerSuccessActionType> = payload => ({
    type: MarkersActionTypes.UPDATE_MARKER_SUCCESS,
    payload,
});
export const updateMarkerFailure: ActionCreator<UpdateMarkerFailureActionType> = payload => ({
    type: MarkersActionTypes.UPDATE_MARKER_FAILURE,
    payload,
});
